<form class="card">
    @if (navigatingToArea) {
        <aurora-loading-indicator overlay></aurora-loading-indicator>
    }
    <h3>Choose an Area</h3>
    <select name="areaSelect" [(ngModel)]="selectedArea" class="form-select mt-2" (ngModelChange)="areaSelected()"
        [disabled]="filteredAreas?.length === 0 || navigatingToArea">
        <option *ngFor="let area of filteredAreas" [ngValue]="area">{{area.Alias || area.Name}}</option>
    </select>
    <aurora-button block 
            name="SelectAreaButton"
            [disabled]="filteredAreas?.length === 0 || navigatingToArea"
            (click)="areaSelect()"
            variant="primary"
            class="mt-3">
        Go
    </aurora-button>
    @if (isModal) {
        <aurora-link-button 
            (click)="onCancel.emit()"
            class="mt-3 full-width justify-content-center">
            Cancel
        </aurora-link-button>
    }
    
    <ng-container *ngIf="!isModal">
        <aurora-link-button
            *sm-has-any-permission="[
                TENANT_PERMISSIONS.Common_SystemAccess,
                TENANT_PERMISSIONS.Common_Tenant,
                TENANT_PERMISSIONS.Common_Programs
            ]"
            class="mt-3 full-width justify-content-center"
            (click)="goToConfig()">
                Go to Configure
        </aurora-link-button>
    </ng-container>
</form>
